module.exports = __webpack_public_path__ + "static/brian_home-a50d1f5965ca4988eb299fee79021966.png";